<div mat-dialog-title>Redigera faktura</div>
<hr />
<mat-dialog-content>
	<div *ngIf="error" class="alert alert-danger">{{ error }}</div>
	<div class="row">
		<div class="col form-group">
			<label>Vår referens</label>
			<input
				#ourReference
				type="text"
				maxlength="50"
				value="{{ invoice.ourReference }}"
				class="form-control"
			/>
		</div>
		<div class="col form-group">
			<label>Deras referens</label>
			<input
				#yourReference
				type="text"
				maxlength="50"
				value="{{ invoice.yourReference }}"
				class="form-control"
			/>
		</div>
	</div>
	<div class="row">
		<div class="col form-group">
			<label>Fakturatext</label>
			<input #remarks type="text" maxlength="1024" class="form-control" value="{{ invoice.remarks }}" />
		</div>
	</div>
</mat-dialog-content>
<hr />
<mat-dialog-actions>
	<div>
		<button
			class="btn btn-primary"
			(click)="
				save(
					ourReference.value,
					yourReference.value,
					remarks.value
				)
			"
		>
			Spara
		</button>
	</div>
	<div>
		<button class="btn btn-secondary" (click)="dialogRef.close()">
			Avbryt
		</button>
	</div>
</mat-dialog-actions>
